// import React, { useState, useRef, useEffect } from "react";
// import { format, differenceInDays } from "date-fns";
// import Calendar from "react-calendar";
// import tw from "tailwind-styled-components";
// import { GoChevronDown } from "react-icons/go";
// import { FaRegCalendarAlt } from "react-icons/fa";
// import { InputGroup, Label } from "../Styles/InputStyles";
// import moment from "moment";

// const DateFilter = ({ setFieldValue }) => {
//     const popupRef = useRef(null);
//     const [showPopup, setShowPopup] = useState(false);
//     const [label, setLabel] = useState("Today");
//     const [startDate, setStartDate] = useState(new Date());
//     const [endDate, setEndDate] = useState(new Date());
//     const [rangeError, setRangeError] = useState("");
//     const [minDate, setMinDate] = useState(null);
//     const [maxDate, setMaxDate] = useState(null);

//     const predefinedRanges = [
//         {
//             label: "Today",
//             startDate: new Date(),
//             endDate: new Date(),
//         },
//         {
//             label: "Yesterday",
//             startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
//             endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
//         },
//         {
//             label: "Last 7 Days",
//             startDate: new Date(new Date().setDate(new Date().getDate() - 6)),
//             endDate: new Date(),
//         }
//     ];

//     useEffect(() => {
//         const today = new Date();
//         const labelText = `Today (${format(today, "dd MMM")} - ${format(today, "dd MMM")})`;
//         setLabel(labelText);

//         setFieldValue('startDate', moment(today).format("YYYY-MM-DD"));
//         setFieldValue('endDate', moment(today).format("YYYY-MM-DD"));
//     }, []);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (popupRef.current && !popupRef.current.contains(e.target)) {
//                 setShowPopup(false);
//             }
//         };

//         if (showPopup) {
//             document.addEventListener("mousedown", handleClickOutside);
//         } else {
//             document.removeEventListener("mousedown", handleClickOutside);
//         }

//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, [showPopup]);

//     const handleRangeSelect = (range) => {
//         setStartDate(range.startDate);
//         setEndDate(range.endDate);
//         const labelText = `${range.label} (${format(range.startDate, "dd MMM")} - ${format(range.endDate, "dd MMM")})`;
//         setLabel(labelText);

//         setFieldValue('startDate', moment(range.startDate).format("YYYY-MM-DD"));
//         setFieldValue('endDate', moment(range.endDate).format("YYYY-MM-DD"));

//         setShowPopup(false);
//         setRangeError("");
//     };

//     const handleDateChange = (range) => {
//         if (Array.isArray(range)) {
//             const daysDiff = differenceInDays(range[1], range[0]);

//             if (!startDate || (range[0] && !range[1])) {
//                 setMinDate(range[0]);
//                 setMaxDate(new Date(range[0].getTime() + 90 * 24 * 60 * 60 * 1000));
//             }

//             if (daysDiff <= 90) {
//                 setStartDate(range[0]);
//                 setEndDate(range[1]);
//                 setRangeError('');
//             } else {
//                 setRangeError("Maximum range is 90 days.");
//             }
//         }
//     };

//     const applyCustomRange = () => {
//         if (!startDate || !endDate) {
//             setRangeError("Please select both start and end dates.");
//             return;
//         }

//         if (startDate.getTime() === endDate.getTime()) {
//             setRangeError("Start and end dates cannot be the same.");
//             return;
//         }

//         const daysDiff = differenceInDays(endDate, startDate);
//         if (daysDiff > 90) {
//             setRangeError("Maximum range is 90 days.");
//             return;
//         }

//         const start = format(startDate, "dd MMM yyyy");
//         const end = format(endDate, "dd MMM yyyy");
//         const customLabel = `${start} - ${end}`;
//         setLabel(customLabel);

//         setFieldValue('startDate', moment(startDate).format("YYYY-MM-DD"));
//         setFieldValue('endDate', moment(endDate).format("YYYY-MM-DD"));

//         setShowPopup(false);
//         setRangeError("");
//     };

//     return (
//         <div className="relative text-left h-12 text-gray-700 mb-6">
//             <InputGroup>
//                 <Label>Duration of the report data</Label>
//                 <Button type="button" onClick={() => setShowPopup(true)}>
//                     <FaRegCalendarAlt className="h-4 w-4 mr-2 text-gray-500" />
//                     <LabelText>{label}</LabelText>
//                     <GoChevronDown className="h-5 w-5 ml-2 text-gray-500" />
//                 </Button>

//                 {showPopup && (
//                     <Overlay>
//                         <Popup ref={popupRef}>
//                             <PopupContent>
//                                 <LeftPanel>
//                                     <DateRangesContainer>

//                                         {predefinedRanges.map((range) => (
//                                             <SidebarButton
//                                                 type="button"
//                                                 key={range.label}
//                                                 onClick={() => handleRangeSelect(range)}
//                                             >
//                                                 {range.label}
//                                                 <span className="text-xs text-gray-500 ml-1">
//                                                     ({format(range.startDate, "dd MMM")} - {format(range.endDate, "dd MMM")})
//                                                 </span>
//                                             </SidebarButton>
//                                         ))}
//                                         <SidebarButton
//                                             type="button"
//                                             onClick={() => {
//                                                 setStartDate(new Date());
//                                                 setEndDate(new Date());
//                                             }}
//                                             className="font-semibold text-primary-color"
//                                         >
//                                             Custom Range
//                                         </SidebarButton>
//                                     </DateRangesContainer>

//                                     <ApplyButtonContainer>
//                                         <div className="text-xs bg-yellow-50 border border-yellow-200 rounded p-2 text-yellow-800 mb-3">
//                                             Maximum range selection is 90 days.
//                                         </div>
//                                         <ApplyButton type="button" onClick={applyCustomRange}>
//                                             Apply
//                                         </ApplyButton>
//                                     </ApplyButtonContainer>
//                                 </LeftPanel>

//                                 <RightPanel>
//                                     <CalendarWrapper>
//                                         <Calendar
//                                             selectRange={true}
//                                             onChange={handleDateChange}
//                                             value={[startDate, endDate]}
//                                             minDate={minDate}
//                                             maxDate={maxDate}
//                                         />
//                                     </CalendarWrapper>
//                                     {rangeError && (
//                                         <ErrorText>{rangeError}</ErrorText>
//                                     )}
//                                     <ApplyButtonContainer className="block md:hidden">
//                                         <div className="text-xs bg-yellow-50 border border-yellow-200 rounded p-2 text-yellow-800 mb-3">
//                                             Maximum range selection is 90 days.
//                                         </div>
//                                         <ApplyButton type="button" onClick={applyCustomRange}>
//                                             Apply
//                                         </ApplyButton>
//                                     </ApplyButtonContainer>
//                                 </RightPanel>
//                             </PopupContent>
//                         </Popup>
//                     </Overlay>
//                 )}
//             </InputGroup>
//         </div>
//     );
// };

// // Styled Components
// const Button = tw.button`
//     w-full text-gray-600 inline-flex items-center px-3 py-2 border border-gray-300 
//     shadow-sm text-sm rounded-md bg-white hover:bg-gray-50 h-12
// `;
// const LabelText = tw.span`truncate flex-1 text-left`;
// const Overlay = tw.div`
//     fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4
// `;
// const Popup = tw.div`
//     bg-white rounded-xl shadow-xl w-full max-w-4xl h-auto max-h-[80vh] overflow-hidden
// `;
// const PopupContent = tw.div`
//     flex flex-col md:flex-row h-full
// `;
// const LeftPanel = tw.div`
//     w-full md:w-1/3 flex flex-col border-b md:border-b-0 md:border-r hidden md:block
// `;
// const RightPanel = tw.div`
//     w-full md:w-2/3 flex flex-col p-4
// `;
// const DateRangesContainer = tw.div`
//     flex-1 overflow-y-auto p-4 space-y-2
// `;
// const ApplyButtonContainer = tw.div`
//     p-4 border-t bg-white
// `;
// const SidebarButton = tw.button`
//     w-full text-left px-3 py-3 rounded-md hover:bg-gray-100 text-sm
//     transition-colors duration-200 border border-transparent hover:border-gray-200
//     ${props => props.className || ''}
// `;
// const ApplyButton = tw.button`
//     w-full bg-primary-color text-white py-3 rounded-md hover:bg-primary-color/90 
//     text-sm font-medium transition-colors duration-200
// `;
// const ErrorText = tw.p`text-red-600 text-sm mt-3 text-center`;
// const CalendarWrapper = tw.div`
//     [&_.react-calendar]:border-0 [&_.react-calendar]:w-full
//     [&_.react-calendar__navigation]:flex-wrap
//     [&_.react-calendar__navigation__label]:text-lg [&_.react-calendar__navigation__label]:font-semibold
//     [&_.react-calendar__tile]:text-sm [&_.react-calendar__tile]:p-2
//     [&_.react-calendar__tile--active]:bg-gray-900 [&_.react-calendar__tile--active]:text-white
//     [&_.react-calendar__tile--active]:rounded-lg
//     [&_.react-calendar__tile--rangeStart]:bg-gray-800 [&_.react-calendar__tile--rangeStart]:text-white
//     [&_.react-calendar__tile--rangeEnd]:bg-gray-800 [&_.react-calendar__tile--rangeEnd]:text-white
//     [&_.react-calendar__tile--range]:bg-gray-200 [&_.react-calendar__tile--range]:text-gray-900
// `;

// export default DateFilter;


import React, { useState, useRef, useEffect } from "react";
import { format, differenceInDays } from "date-fns";
import Calendar from "react-calendar";
import tw from "tailwind-styled-components";
import { GoChevronDown } from "react-icons/go";
import { FaRegCalendarAlt } from "react-icons/fa";
import { InputGroup, Label } from "../Styles/InputStyles";
import moment from "moment";
import { IoClose } from "react-icons/io5";

const DateFilter = ({ setFieldValue }) => {
    const popupRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
    const [label, setLabel] = useState("Today");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [rangeError, setRangeError] = useState("");
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);

    const predefinedRanges = [
        {
            label: "Today",
            startDate: new Date(),
            endDate: new Date(),
        },
        {
            label: "Yesterday",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
        },
        {
            label: "Last 7 Days",
            startDate: new Date(new Date().setDate(new Date().getDate() - 6)),
            endDate: new Date(),
        }
    ];

    useEffect(() => {
        const today = new Date();
        const labelText = `Today (${format(today, "dd MMM")} - ${format(today, "dd MMM")})`;
        setLabel(labelText);

        setFieldValue('startDate', moment(today).format("YYYY-MM-DD"));
        setFieldValue('endDate', moment(today).format("YYYY-MM-DD"));
    }, []);

    const handleRangeSelect = (range) => {
        setStartDate(range.startDate);
        setEndDate(range.endDate);
        const labelText = `${range.label} (${format(range.startDate, "dd MMM")} - ${format(range.endDate, "dd MMM")})`;
        setLabel(labelText);

        setFieldValue('startDate', moment(range.startDate).format("YYYY-MM-DD"));
        setFieldValue('endDate', moment(range.endDate).format("YYYY-MM-DD"));

        setShowPopup(false);
        setRangeError("");
    };

    const handleDateChange = (range) => {
        if (Array.isArray(range)) {
            setStartDate(range[0]);
            setEndDate(range[1]);
            setRangeError("");
        }
    };

    const applyCustomRange = () => {
        if (!startDate || !endDate) {
            setRangeError("Please select both start and end dates.");
            return;
        }

        // Check if end date is before start date
        if (endDate < startDate) {
            setRangeError("End date cannot be before start date.");
            return;
        }

        const start = format(startDate, "dd MMM yyyy");
        const end = format(endDate, "dd MMM yyyy");
        const customLabel = `${start} - ${end}`;
        setLabel(customLabel);

        setFieldValue('startDate', moment(startDate).format("YYYY-MM-DD"));
        setFieldValue('endDate', moment(endDate).format("YYYY-MM-DD"));

        setShowPopup(false);
        setRangeError("");
    };

    const closePopup = () => {
        setShowPopup(false);
        setRangeError("");
    };

    return (
        <div className="relative text-left h-12 text-gray-700 mb-6">
            <InputGroup>
                <Label>Duration of the report data</Label>
                <Button type="button" onClick={() => setShowPopup(true)}>
                    <FaRegCalendarAlt className="h-4 w-4 mr-2 text-gray-500" />
                    <LabelText>{label}</LabelText>
                    <GoChevronDown className="h-5 w-5 ml-2 text-gray-500" />
                </Button>

                {showPopup && (
                    <Overlay>
                        <Popup ref={popupRef}>
                            <PopupHeader>
                                <PopupTitle>Select Date Range</PopupTitle>
                                <CloseButton type="button" onClick={closePopup}>
                                    <IoClose className="h-6 w-6" />
                                </CloseButton>
                            </PopupHeader>
                            <PopupContent>
                                <LeftPanel>
                                    <DateRangesContainer>
                                        {predefinedRanges.map((range) => (
                                            <SidebarButton
                                                type="button"
                                                key={range.label}
                                                onClick={() => handleRangeSelect(range)}
                                            >
                                                {range.label}
                                                <span className="text-xs text-gray-500 ml-1">
                                                    ({format(range.startDate, "dd MMM")} - {format(range.endDate, "dd MMM")})
                                                </span>
                                            </SidebarButton>
                                        ))}
                                        <SidebarButton
                                            type="button"
                                            onClick={() => {
                                                setStartDate(new Date());
                                                setEndDate(new Date());
                                            }}
                                            className="font-semibold text-primary-color"
                                        >
                                            Custom Range
                                        </SidebarButton>
                                    </DateRangesContainer>

                                    <ApplyButtonContainer>
                                        <ApplyButton type="button" onClick={applyCustomRange}>
                                            Apply
                                        </ApplyButton>
                                    </ApplyButtonContainer>
                                </LeftPanel>

                                <RightPanel>
                                    <CalendarWrapper>
                                        <Calendar
                                            selectRange={true}
                                            onChange={handleDateChange}
                                            value={[startDate, endDate]}
                                            minDate={null}
                                            maxDate={null}
                                        />
                                    </CalendarWrapper>
                                    {rangeError && (
                                        <ErrorText>{rangeError}</ErrorText>
                                    )}
                                    <ApplyButtonContainer className="block md:hidden">
                                        <ApplyButton type="button" onClick={applyCustomRange}>
                                            Apply
                                        </ApplyButton>
                                    </ApplyButtonContainer>
                                </RightPanel>
                            </PopupContent>
                        </Popup>
                    </Overlay>
                )}
            </InputGroup>
        </div>
    );
};

// Styled Components
const Button = tw.button`
    w-full text-gray-600 inline-flex items-center px-3 py-2 border border-gray-300 
    shadow-sm text-sm rounded-md bg-white hover:bg-gray-50 h-12
`;
const LabelText = tw.span`truncate flex-1 text-left`;
const Overlay = tw.div`
    fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4
`;
const Popup = tw.div`
    bg-white rounded-xl shadow-xl w-full max-w-4xl h-auto max-h-[80vh] overflow-hidden
`;
const PopupHeader = tw.div`
    flex justify-between items-center px-6 py-4 border-b
`;
const PopupTitle = tw.h3`
    text-lg font-semibold text-gray-800
`;
const CloseButton = tw.button`
    text-gray-500 hover:text-gray-700 transition-colors duration-200
    p-1 rounded-full hover:bg-gray-100
`;
const PopupContent = tw.div`
    flex flex-col md:flex-row h-full
`;
const LeftPanel = tw.div`
    w-full md:w-1/3 flex flex-col border-b md:border-b-0 md:border-r hidden md:block
`;
const RightPanel = tw.div`
    w-full md:w-2/3 flex flex-col p-4
`;
const DateRangesContainer = tw.div`
    flex-1 overflow-y-auto p-4 space-y-2
`;
const ApplyButtonContainer = tw.div`
    p-4 border-t bg-white
`;
const SidebarButton = tw.button`
    w-full text-left px-3 py-3 rounded-md hover:bg-gray-100 text-sm
    transition-colors duration-200 border border-transparent hover:border-gray-200
    ${props => props.className || ''}
`;
const ApplyButton = tw.button`
    w-full bg-primary-color text-white py-3 rounded-md hover:bg-primary-color/90 
    text-sm font-medium transition-colors duration-200
`;
const ErrorText = tw.p`text-red-600 text-sm mt-3 text-center`;
const CalendarWrapper = tw.div`
    [&_.react-calendar]:border-0 [&_.react-calendar]:w-full
    [&_.react-calendar__navigation]:flex-wrap
    [&_.react-calendar__navigation__label]:text-lg [&_.react-calendar__navigation__label]:font-semibold
    [&_.react-calendar__tile]:text-sm [&_.react-calendar__tile]:p-2
    [&_.react-calendar__tile--active]:bg-gray-900 [&_.react-calendar__tile--active]:text-white
    [&_.react-calendar__tile--active]:rounded-lg
    [&_.react-calendar__tile--rangeStart]:bg-gray-800 [&_.react-calendar__tile--rangeStart]:text-white
    [&_.react-calendar__tile--rangeEnd]:bg-gray-800 [&_.react-calendar__tile--rangeEnd]:text-white
    [&_.react-calendar__tile--range]:bg-gray-200 [&_.react-calendar__tile--range]:text-gray-900
`;

export default DateFilter;